import React, { useState } from 'react';
import './styles.css';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // Ici vous ajouteriez la logique pour envoyer le formulaire
    alert('Message envoyé ! Nous vous contacterons bientôt.');
    // Réinitialiser le formulaire
    setFormData({
      name: '',
      email: '',
      subject: '',
      message: ''
    });
  };

  return (
    <section id="contact" className="contact">
      <div className="contact-container">
        <div className="section-title">
          <h2>Contactez-Nous</h2>
          <p>Vous avez un projet ou une question ? N'hésitez pas à nous contacter !</p>
        </div>
        
        <div className="contact-content">
          <div className="contact-info">            
            <div className="info-item">
              <i className="info-icon">📧</i>
              <div>
                <h3>Email</h3>
                <p>admin@stoa-consult.eu</p>
              </div>
            </div>
            
            <div className="info-item">
              <i className="info-icon">📞</i>
              <div>
                <h3>Téléphone</h3>
                <p>+32 484 68 15 13</p>
              </div>
            </div>
            
            <div className="social-links">
              <h3>Suivez-nous</h3>
              <div className="social-icons">
                <a href="#" className="social-icon">FB</a>
                <a href="#" className="social-icon">TW</a>
                <a href="#" className="social-icon">IG</a>
                <a href="#" className="social-icon">LI</a>
              </div>
            </div>
          </div>
          
          <div className="contact-form">
            <h3>Envoyez-nous un message</h3>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <input 
                  type="text" 
                  name="name" 
                  placeholder="Votre Nom" 
                  value={formData.name}
                  onChange={handleChange}
                  required 
                />
              </div>
              
              <div className="form-group">
                <input 
                  type="email" 
                  name="email" 
                  placeholder="Votre Email" 
                  value={formData.email}
                  onChange={handleChange}
                  required 
                />
              </div>
              
              <div className="form-group">
                <input 
                  type="text" 
                  name="subject" 
                  placeholder="Sujet" 
                  value={formData.subject}
                  onChange={handleChange}
                  required 
                />
              </div>
              
              <div className="form-group">
                <textarea 
                  name="message" 
                  placeholder="Votre Message" 
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>
              
              <button type="submit" className="btn primary-btn">Envoyer Message</button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;